import {
  mdiFacebook,
  mdiInstagram,
  mdiOdnoklassniki,
  mdiTelegram,
  mdiTwitter,
  mdiVk,
  mdiWhatsapp,
  mdiYoutube,
} from '@mdi/js'

export interface ISocialIcon {
  path: string
  color: string
  viewBox?: string
}

/**
 * Глиф MAX вырезан из `max.svg`: убраны градиентные подложки, оставлен только
 * сам знак. viewBox подогнан по его bbox (764x761 с центром 500,500).
 */
const maxPath =
  'M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.785 0 375.947 171.001 375.947 381.604.707 207.346-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574Z'

/**
 * Глиф RUTUBE вырезан из `rutube.svg`: убраны тёмная плашка и красный круг,
 * оставлен знак «R». viewBox подогнан по его bbox (80x66 с центром 66,66).
 */
const rutubePath =
  'M81.536 62.986H42.54v-15.43h38.997c2.278 0 3.862.397 4.657 1.09.795.694 1.287 1.98 1.287 3.858v5.541c0 1.98-.492 3.265-1.287 3.959-.795.693-2.379.99-4.657.99v-.007Zm2.675-29.98H26V99h16.539V77.53h30.479L87.48 99H106L90.055 77.429c5.878-.871 8.518-2.673 10.695-5.642 2.177-2.97 3.269-7.716 3.269-14.051v-4.948c0-3.758-.398-6.727-1.092-9.002-.694-2.276-1.88-4.255-3.565-6.033-1.78-1.683-3.76-2.868-6.14-3.663-2.378-.693-5.35-1.09-9.01-1.09v.006Z'

/**
 * Одноцветные глифы соцсетей: в покое красятся в `$gray`, на ховере —
 * в фирменный цвет из `color`. Ключи совпадают с ключами `social`
 * и `socialHeader` из конфига сайта.
 */
export const socialIcons: { [key: string]: ISocialIcon } = {
  vk: { path: mdiVk, color: '#0077ff' },
  odnoklassniki: { path: mdiOdnoklassniki, color: '#ee8208' },
  instagram: { path: mdiInstagram, color: '#e4405f' },
  twitter: { path: mdiTwitter, color: '#1da1f2' },
  facebook: { path: mdiFacebook, color: '#1877f2' },
  youtube: { path: mdiYoutube, color: '#ff0000' },
  telegram: { path: mdiTelegram, color: '#2aabee' },
  whatsapp: { path: mdiWhatsapp, color: '#25d366' },
  max: { path: maxPath, color: '#5533ee', viewBox: '75 75 850 850' },
  rutube: { path: rutubePath, color: '#ed143b', viewBox: '21 21 90 90' },
}
